module.exports = __webpack_public_path__ + "img/bicycle_mechanic.d1389d2e.png";